import { ApiClient as UtcomApiSdk } from '@unitedtraders/utcom-api-sdk';
import { inject, injectable } from 'inversify';
import { RootLogger } from 'loglevel';
import { AppConfig } from '../types/common';
import { iocNames } from '../iocNames';
import { GetTokens } from '../types/RootUpdatable';

@injectable()
export class UtcomApi extends UtcomApiSdk {
  constructor(
    @inject(iocNames.config) config: AppConfig,
    @inject(iocNames.logger) logger: RootLogger,
    @inject(iocNames.getTokens) getTokens: GetTokens
  ) {
    super(config.utcomGateway, logger.getLogger('UtcomGateway'), getTokens);
  }
}
